import React, {FC} from 'react';
import styled from 'styled-components';

import {ViewerPanelId} from '../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {SynopsisCellDetail, SynopsisSummary} from './synopsisCellDetail';
import {SynopsisCellHeaderContainer} from './synopsisCellHeaderContainer';
import {SynopsisCommentItem} from './synopsisHelpers';
import {SynopsisQuickAction, SynopsisQuickActionsEnum} from './synopsisQuickAction';
import {useSynopsisViewerContext} from './synopsisViewerContext';

interface SynopsisCommentPreviewProps {
  item: SynopsisCommentItem;
  isFollowUp?: boolean;
  panelId: ViewerPanelId;
}

const StyledCellDiv = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px 0;
  border-radius: 12px;
  background-color: ${(p) => p.theme.message.readCommentBackground};
`;

export const SynopsisCommentPreview: FC<SynopsisCommentPreviewProps> = ({item, isFollowUp, panelId}) => {
  const {authorIds, summary, timestamp, activityId} = item;
  const {onJumpToItem, onFeedbackAction, namespace, setCopyText} = useSynopsisViewerContext();

  return (
    <StyledCellDiv
      onMouseEnter={() => setCopyText(`${summary.verb} ${summary.remainder}`)}
      onMouseLeave={() => setCopyText('')}
    >
      {!isFollowUp && (
        <SynopsisCellHeaderContainer
          teammateIds={authorIds}
          timestamp={timestamp}
          namespace={namespace}
          panelId={panelId}
        />
      )}
      <SynopsisCellDetail
        isFollowUp={isFollowUp}
        actions={
          <SynopsisQuickAction
            actionId={SynopsisQuickActionsEnum.FEEDBACK}
            onClick={() =>
              onFeedbackAction({
                activity_id: activityId,
                type: 'takeaway',
                origin: 'comment',
                node_id: item.id,
              })
            }
          />
        }
        timestamp={timestamp}
        onClick={() => onJumpToItem({activityId, itemType: 'comment'})}
      >
        <SynopsisSummary summary={summary} />
      </SynopsisCellDetail>
    </StyledCellDiv>
  );
};
